module.exports = __webpack_public_path__ + "static/media/placeholder.8714556a.png";